import React from 'react';

export { default as LightenDarkenColor } from './LightenDarkenColor';

function limitText(text, limit = 400) {
  // console.log(text, limit);
  let newText = text.substring(0, limit);

  if (text !== newText) {
    newText = `${newText}... `;
  }

  return newText;
}

export function limitTheTextReadMore(text, url, limit = 400) {
  const newText = limitText(text, limit);

  const buttonUrl = (
    <a
      className="mr-2 btn-transition btn btn-outline-link btn-sm"
      href={url}
    >
      Ler mais
    </a>
  );

  return (
    <>
      {newText}
      {buttonUrl}
    </>
  );
}

export function LimitTheText(text, limit = 400) {
  return limitText(text, limit);
}
